import { assignAuthRequests } from "./apiRequests/authRequests";
import { assignMiscRequests } from "./apiRequests/miscRequests";
import { assignTfaRequests } from "./apiRequests/tfaRequests";
import { assignServiceAccountRequests } from "./apiRequests/serviceAccountRequests";
import { assignRepositoryRequests } from "./apiRequests/repositoryRequests";
import { assignPcRequests } from "./apiRequests/pcRequests";
import { assignGroupRequests } from "./apiRequests/groupRequests";
import { assignPolicyRequests } from "./apiRequests/policyRequests";
import { assignBackupRequests } from "./apiRequests/backupRequests";
import { assignRestoreRequests } from "./apiRequests/restoreRequests";
import { assignUserRequests } from "./apiRequests/userRequests";
import { assignScriptRequests } from "./apiRequests/scriptRequests";

import { assignTeamRequests } from "./apiRequests/ticketing/teamRequests";
import { assignTicketRequests } from "./apiRequests/ticketing/ticketRequests";
import { assignCustomerRequests } from "./apiRequests/ticketing/customerRequests";
import { assignBillingRequests } from "./apiRequests/ticketing/billingRequests";

export function assignPrototypesToAPI(api) {
    assignAuthRequests(api);
    assignMiscRequests(api);
    assignTfaRequests(api);
    assignServiceAccountRequests(api);
    assignRepositoryRequests(api);
    assignPcRequests(api);
    assignGroupRequests(api);
    assignPolicyRequests(api);
    assignBackupRequests(api);
    assignRestoreRequests(api);
    assignUserRequests(api);
    assignScriptRequests(api);

    assignTeamRequests(api);
    assignTicketRequests(api);
    assignCustomerRequests(api);
    assignBillingRequests(api);
}